/**
 * Walk the Lincoln proxy response body to find the rows array.
 * Lincoln wraps responses in varying levels of { data: ... } nesting.
 * Tries: body, body.data, body.data.data, body.data.data.data,
 * then checks if any of those levels is an object with a single array-valued key.
 */
export function extractBdxRows(body) {
    const d1 = body && body.data
    const d2 = d1 && d1.data
    const d3 = d2 && d2.data
    const candidates = [body, d1, d2, d3]
    for (let i = 0; i < candidates.length; i++) {
        const c = candidates[i]
        if (Array.isArray(c)) return c
        if (c && typeof c === 'object') {
            const keys = Object.keys(c)
            for (let j = 0; j < keys.length; j++) {
                if (Array.isArray(c[keys[j]])) return c[keys[j]]
            }
        }
    }
    return []
}
